import styled from "styled-components";
import { MOBILE } from "../../constants/breakpoints";
import assetInput_bg from "../../assets/assetInput_bg.svg";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
export const SelectList = styled.select`
    width: 416px;
    background: #ffffff;
    border: 1px solid #ccc4b3;
    border-radius: 12px;
    padding: 12px 24px;
    font-weight: 400;
    font-size: 14px;
    margin-top: 48px;

    @media (max-width: ${MOBILE}px) {
        width: 100%;
    }
`

export const WalletInputContainer = styled.section`
    display: flex;
    width: 100%;
    height: 100vh;
    position: fixed;
    background: rgba(27, 31, 36, 0.74);
    z-index: 1000;
    justify-content: center;
    align-items: center;
`
export const WalletInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 544px;
    background-color: white;
    padding: 64px;
    box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
    0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481),
    0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185),
    0px 20px 13px rgba(0, 0, 0, 0.035),
    0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815),
    0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519);
    border-radius: 24px;
    align-items: center;
    background: url(${assetInput_bg});
    background-repeat: no-repeat;
    background-size: cover;
    @media (max-width: ${MOBILE}px) {
        width: 95%;
        padding: 49px 24px;
    }
    .promptText {
        text-align: center;
        margin: 0;
        font-weight: 700;
        font-size: 24px;
        line-height: 150%;
        @media (max-width: ${MOBILE}px) {
            font-weight: 700;
            font-size: 16px;
            width: 70%;
        }
    }
    .promptDescription {
        text-align: center;
        margin: 0;
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        width: 333px;
        color: #757272;
        @media (max-width: ${MOBILE}px) {
            font-weight: 400;
            font-size: 14px;
            width: 95%;
            margin-top: 16px;
        }
    }
`

export const InputEl = styled.input`
    width: 416px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #ccc4b3;
    border-radius: 12px;
    padding: 12px 24px;
    font-weight: 400;
    font-size: 14px;
    margin-top: 30px;

    @media (max-width: ${MOBILE}px) {
        width: 100%;
    }
`

export const AddButton = styled.button`
    background: #ffd550;
    border-radius: 12px;
    width: 416px;
    height: 47.5px;
    border: none;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    margin-top: 30px;

    @media (max-width: ${MOBILE}px) {
        width: 100%;
    }
`